import React from "react";
import Breadcrumb from "../components/Breadcrumb";
import EditProjectLayer from "../components/EditProjectLayer";

const EditProjectPage = () => {
  return (
    <>
      <Breadcrumb title="Edit Project" />
      <EditProjectLayer />
    </>
  );
};

export default EditProjectPage;
